export const programVignettesTypes = [
	'VIGNETTE-PROGRAM-INTRO',
	'VIGNETTE-BREAK',
	'VIGNETTE-PROGRAM-OUTRO',
	'VIGNETTE-BLOCK-INTRO',
	'VIGNETTE-BLOCK-OUTRO',
	'SIGNATURE-PROGRAM',
];
